import React from 'react';
import mnb from '@music/mnb';

import { style } from './index.less';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadError: false,
        };
    }

    static getDerivedStateFromError(error) {
        const loadError = error.name === 'ChunkLoadError';
        return { loadError };
    }

    componentDidCatch(error) {
        console.error('ErrorBoundary', error);
        if (error.name !== 'ChunkLoadError') {
            // eslint-disable-next-line
      Raven && Raven.captureException && Raven.captureException(error);
        }
    }

  handleBack = () => {
      mnb.close();
  }

  handleReload = () => {
      window.location.reload();
  }

  render() {
      if (this.state.loadError) {
          return (
              <div className={style}>
                  <img src="https://p1.music.126.net/hALmXjYYt6NOPwAM1LYngw==/109951164442041855.png?imageView&quality=75" alt="加载失败" />
                  <p>抱歉，页面加载失败！</p>
                  <div className="btn-group">
                      <div className="btn-left" onClick={this.handleBack}>返回</div>
                      <div className="btn-right" onClick={this.handleReload}>重试</div>
                  </div>
              </div>
          );
      }

      // eslint-disable-next-line
    return this.props.children;
  }
}
